import { useSyncExternalStore } from "react";
import { getTheme, setTheme, subscribeTheme, type ThemeMode } from "@/lib/theme";

export function useTheme(): [ThemeMode, (mode: ThemeMode) => void] {
  const mode = useSyncExternalStore(subscribeTheme, getTheme);
  return [mode, setTheme];
}
